<template>
  <van-dialog
    v-model="show"
    class="dialog"
    show-cancel-button
    @close="confirm"
    @confirm="confirm"
  >
    <van-form style="position: relative; margin-top: 2rem; display: flex">
      <van-field v-model="formData.name" name="name" label="仓库名称" />
      <van-button type="primary" :loading="loading" @click="search"
        >查询</van-button
      >
    </van-form>
    <van-list
      class="scrollList"
      :finished="finished"
      :loading-text="'加载中...'"
      :finished-text="'已显示全部'"
      @load="onLoad"
      v-model="loading"
      :error="error"
      :error-click="search"
    >
      <van-cell
        ref="cell"
        v-for="item in categoryList"
        :key="item.name"
        :title="item.name"
        @click="showActive(item)"
      />
    </van-list>
  </van-dialog>
</template>
<script>
import { AVAILABLE } from "../utils/constants";
import { reqSc } from "../service/api/product";
// 导入样式
export default {
  name: "stockSelect",
  components: {},
  props: {
    visible: false,
  },
  data() {
    return {
      error:false,
      loading: false,
      finished: false,
      show: false,
      data: [],
      formData: { name: "", available: true, pageIndex: 1, pageSize: 20 },
      columns: [
        {
          label: "编号",
          prop: "id",
        },
        {
          label: "名称",
          prop: "name",
        },
        {
          label: "状态",
          prop: "available",
        },
      ],
      statusList: AVAILABLE,
      categoryList: [],
      currentRow: {},
    };
  },
  watch: {
    visible(newVal, oldVal) {
      this.show = newVal;
    },
  },
  mounted() {
    
    this.getProductList();
  },
  methods: {
    onLoad() {
      
      this.formData.pageIndex++;
      this.getProductList(true);
    },
    search() {
      this.formData.pageIndex = 1;
      this.getProductList();
      // const ids = this.data.reduce((pre, cur) => {
      //   if (cur.name.includes(this.formData.name)) {
      //     pre.push(cur.id);
      //     if (cur.parentId) {
      //       pre.push(cur.parentId);
      //     }
      //   }
      //   return pre;
      // }, []);
      // this.categoryList = this.data.filter((el) => {
      //   return ids.findIndex((i) => i === el.id) !== -1;
      // });
    },
    showActive(item) {
      this.currentRow = item;
      const exitIndex = this.categoryList.findIndex((i) => i.id === item.id);
      this.$refs.cell.forEach((el, index) => {
        el.classList.remove("active");
        if (index == exitIndex) {
          el.classList.add("active");
        }
      });
    },
    confirm() {
      this.$emit("confirm", this.currentRow);
      this.show = false;
      this.currentRow = {};
    },
    getProductList(flag) {
      this.finished = false;
      this.loading = true;
      reqSc(this.formData)
        .then((res) => {
          debugger
          if (flag) {
            
            this.data=this.data.concat(res.data.datas);
            
          } else {
            this.data = res.data.datas;
          }
          this.categoryList = this.data;
          if (this.formData.pageIndex >= res.data.totalPage) {
            this.finished = true;
          }
        })
        .catch(() => {
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
.active {
  background: #1989fa;
}
.dialog {
  height: 80%;
}

::v-deep .van-dialog__content {
  height: 100%;

  // .van-form {
  //   height: 100%;
  // }
}

.scrollList {
  height: calc(100% - 115px) !important;

  overflow: auto;
}
::v-deep .van-dialog__footer {
  position: sticky;
  bottom: 0;
}
</style>
